function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "events-clip-path"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-313.991,154.519a35.888,35.888,0,0,0-3.853-5.171c-.018-.019-.037-.037-.055-.056-.521-1.922-3.266-1.574-3.772-.247a2.465,2.465,0,0,0-.127.513,2.984,2.984,0,0,0-.12.876,2.557,2.557,0,0,0,.121.828,33.142,33.142,0,0,1,.366,4.153c-.121,1.83-3.617,4.811-3.617,4.811l.3.881a26.338,26.338,0,0,0,4.642-2.914c.658-.633,1.248-2.888,1.663-4.909,3.926,1.824,4.2,9.167,4.2,9.167l1.018-.407S-312.769,156.42-313.991,154.519Z",
  transform: "translate(325.047 -147.95)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "events-clip-path-2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-234.754,128.279a4.07,4.07,0,0,0,3.05-.923c1.236-1.167,2.856-3.97,5.053-4.313s3.878,2.205,5.8,1.244a9.951,9.951,0,0,0,2.663-1.759l.481.137a6.183,6.183,0,0,1-2.936,3.64,4,4,0,0,1-3.352-.147l.349,2.994a5.954,5.954,0,0,1-2.745.648c-.911-.089-1.7-.249-1.7-.249l-.3-3.044a8.313,8.313,0,0,1-2.867,2.132,4.913,4.913,0,0,1-3.5.326Z",
  transform: "translate(234.754 -122.528)",
  fill: "#fff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-295.644,94.825s-1.759.749-2.957,1.273c-1.022.447-.449-1.8-.449-1.8l-.649.081s-2.158,3.78.2,3.443S-293.812,95.645-295.644,94.825Z",
  transform: "translate(304.967 -91.928)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-313.991,154.519a35.888,35.888,0,0,0-3.853-5.171c-.018-.019-.037-.037-.055-.056-.521-1.922-3.266-1.574-3.772-.247a2.465,2.465,0,0,0-.127.513,2.984,2.984,0,0,0-.12.876,2.557,2.557,0,0,0,.121.828,33.142,33.142,0,0,1,.366,4.153c-.121,1.83-3.617,4.811-3.617,4.811l.3.881a26.338,26.338,0,0,0,4.642-2.914c.658-.633,1.248-2.888,1.663-4.909,3.926,1.824,4.2,9.167,4.2,9.167l1.018-.407S-312.769,156.42-313.991,154.519Z",
  transform: "translate(326.134 -138.387)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(1.087 9.563)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-313.991,154.519a35.888,35.888,0,0,0-3.853-5.171c-.018-.019-.037-.037-.055-.056-.521-1.922-3.266-1.574-3.772-.247a2.465,2.465,0,0,0-.127.513,2.984,2.984,0,0,0-.12.876,2.557,2.557,0,0,0,.121.828,33.142,33.142,0,0,1,.366,4.153c-.121,1.83-3.617,4.811-3.617,4.811l.3.881a26.338,26.338,0,0,0,4.642-2.914c.658-.633,1.248-2.888,1.663-4.909,3.926,1.824,4.2,9.167,4.2,9.167l1.018-.407S-312.769,156.42-313.991,154.519Z",
  transform: "translate(325.047 -147.95)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0)",
  clipPath: "url(#events-clip-path)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.164 0.919)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-301.87,161.132a2.013,2.013,0,0,0,1.247.748",
  transform: "translate(304.814 -160.284)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-323.824,166.683s3.843-1.946,4.242-3.992a31.233,31.233,0,0,0,.4-5.539,5.513,5.513,0,0,1,.9-2.346",
  transform: "translate(323.824 -154.806)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-273.545,174.853s2.988,2.851,3.587,4.3.848,6.587.848,6.587",
  transform: "translate(280.288 -172.164)",
  fill: "#fff"
})))), /*#__PURE__*/React.createElement("path", {
  d: "M-253.8,92.092l1.366,1.02,1.152-1.537-1.246-.653Z",
  transform: "translate(264.443 -89.008)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-294.958,96.788c2.582-.374,2.545,1.31,2.508,2.358a5.91,5.91,0,0,1-1.048,3.032,17.536,17.536,0,0,1-2.064,2.872c-.93.871-4.672-.29-4.635-1.076S-297.637,97.176-294.958,96.788Z",
  transform: "translate(304.618 -94.04)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-272.407,111.2c-1.332.869-2.451,2.948-2.346,3.443.349,1.647,4.042,3.443,4.042,3.443l.449-.549s-2.046-1.647-2-2.944c.019-.494,1.182-1.8,1.347-2.4C-270.641,111.234-271.259,110.454-272.407,111.2Z",
  transform: "translate(282.591 -106.309)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-294.327,86.127a1.646,1.646,0,0,1,.025-1,.659.659,0,0,1,.649-.374c.2-.025.537.55.424.649-.2.175-.324.649-.574.724A1.085,1.085,0,0,1-294.327,86.127Z",
  transform: "translate(299.595 -83.666)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-290.522,87.141s.431-.555.624-.324c.125.15-.324.6-.324.6",
  transform: "translate(296.239 -85.403)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-244.2,80.822a1.342,1.342,0,0,0-1.177-1.489,1.342,1.342,0,0,0-1.489,1.177c-.086.736,1.087,1.929,1.823,2.015a.536.536,0,0,0,.576-.323.9.9,0,0,1-.245-.341l.36.029c.025-.1.046-.2.063-.305.114.015.248.033.279.033A4.093,4.093,0,0,0-244.2,80.822Z",
  transform: "translate(258.442 -78.964)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-246.4,78.341c-.245.134-.084.571,0,.655s-.823-.065-.908-.168a2.352,2.352,0,0,1-.215-.954c0-.337.187-.861.477-.861h.29s.066-.487.767-.346,1.17.851,1.628.777.225.421.019.5a12.333,12.333,0,0,1-1.394-.084.248.248,0,0,0-.187.412c.122.1.028.515-.122.449S-246.09,78.172-246.4,78.341Z",
  transform: "translate(259.006 -76.641)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-244.119,160.386s.861-.012.936.137a1.986,1.986,0,0,1,.125.362s.15.412.15.449a1.546,1.546,0,0,1-.786.5c-.287,0-.873-.9-.873-.9Z",
  transform: "translate(256.448 -149.155)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-332.065,239.481s-1.158.172-1.084.621,1.148,2.795,1.347,2.5a8.506,8.506,0,0,0,.038-2.235Z",
  transform: "translate(333.152 -217.642)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-244.961,253.443s-.208,1.09.092,1.09,3.368-.848,2.77-1.148a6.042,6.042,0,0,0-1.843-.35Z",
  transform: "translate(256.85 -229.379)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-115.262,120.888a4.684,4.684,0,0,1-.038-.772,1.948,1.948,0,0,1,.19-.4c.076-.089.354-.076.595-.038s.557.62.468.8-.751.493-.751.493Z",
  transform: "translate(144.526 -113.877)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-219.428,97.413a3.079,3.079,0,0,0-1.829-.327c-1.7.58-1.756,1.8-1.242,2.548.588.849-2.613.784-1.895,2.875s-1.181,1.022-.849,1.895,3.9,1.193,6.251-1.224,1.72-.474,2.5-1.716c.482-.763-.061-2.4-1.5-3.855A1.368,1.368,0,0,0-219.428,97.413Z",
  transform: "translate(239.749 -94.294)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-181.851,112.206c-.358.31.149,2.691.149,2.691l1.347-.187S-181.328,111.753-181.851,112.206Z",
  transform: "translate(202.253 -107.396)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-267.67,178.2l.5.8s8.908-5.913,11.153-6.063c.67-.045-1.253,1.975-1.173,2.944.116,1.4,2,5.914,2,5.914l.873-.449s-1.484-4.628-.873-5.265c.844-.881,3.837-3.634,2.5-6.15S-267.67,178.2-267.67,178.2Z",
  transform: "translate(276.452 -157.09)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-234.754,131.4a8.9,8.9,0,0,0,2.9-1.073c1.46-.861,3.005-3.82,5.2-4.163s3.99,2.205,5.913,1.244,2.1-1.273,2.1-1.273l.368.374a3.806,3.806,0,0,1-2.368,2.916,4,4,0,0,1-3.352-.147l.349,2.994a5.954,5.954,0,0,1-2.745.648c-.911-.089-1.7-.249-1.7-.249l-.3-3.044a8.314,8.314,0,0,1-2.867,2.132,4.913,4.913,0,0,1-3.5.326Z",
  transform: "translate(247.951 -119.492)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-190.2,106.016a1.125,1.125,0,0,0-1.368-.813,1.125,1.125,0,0,0-.813,1.368c.023.091.046.188.07.286-.06.146-.112.3-.063.3a.629.629,0,0,0,.137-.017c.13.457.321.858.745.75C-190.886,107.739-190.043,106.618-190.2,106.016Z",
  transform: "translate(211.287 -101.343)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-190.336,104.429s.586-.3.749.1c.3.744.387.4.387.4s-.012-.268.175-.2.218.5.044.655.53.568.836.393.237-1.347-.362-1.7S-190.342,103.955-190.336,104.429Z",
  transform: "translate(209.49 -100.246)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-242.31,162.059s-.582-.548-.822-.548a.755.755,0,0,0-.525.194c-.137.114-.263,1.016-.046,1.073a3.1,3.1,0,0,0,1.167-.114C-242.333,162.573-242.31,162.059-242.31,162.059Z",
  transform: "translate(255.801 -150.129)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(13.197 6.154)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-234.754,128.279a4.07,4.07,0,0,0,3.05-.923c1.236-1.167,2.856-3.97,5.053-4.313s3.878,2.205,5.8,1.244a9.951,9.951,0,0,0,2.663-1.759l.481.137a6.183,6.183,0,0,1-2.936,3.64,4,4,0,0,1-3.352-.147l.349,2.994a5.954,5.954,0,0,1-2.745.648c-.911-.089-1.7-.249-1.7-.249l-.3-3.044a8.313,8.313,0,0,1-2.867,2.132,4.913,4.913,0,0,1-3.5.326Z",
  transform: "translate(234.754 -122.528)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)",
  clipPath: "url(#events-clip-path-2)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M-187.452,124.859a3.511,3.511,0,0,0,2.62.711,2.526,2.526,0,0,0,1.647-1.647l-3.032.037Z",
  transform: "translate(193.796 -123.736)",
  fill: "#fff"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M-280.415,228.135s-1.921-1.166-1.921-.87,1.236,2.23,1.586,2.15a1.991,1.991,0,0,0,.984-.58Z",
  transform: "translate(289.151 -207.023)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-183.732,257.556s-1.614,1.04-1.355,1.25,2.51-.451,2.707-.49-.478-1.185-.478-1.185Z",
  transform: "translate(204.969 -232.926)",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M-165.9,125.288a12.19,12.19,0,0,1,.046,1.343c.048-.021.094-.043.139-.067.02-.415-.048-1.247-.052-1.287Z",
  transform: "translate(188.334 -118.755)",
  fill: "#fff"
}));

var SvgEvents = function SvgEvents(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "events",
    className: "fill",
    width: 30.494,
    height: 25.922,
    viewBox: "0 0 30.494 25.922",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEvents, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/events.23b067a1.svg";
export { ForwardRef as ReactComponent };